import api from '../utils/api';

export const searchResults = (config = {}) => {
    const { data, options, signal } = config;
    return api({
        url: `api/content/search`,
        method: "POST",
        data: data,
        signal, // Pass the abort signal to the API call
        ...options,
    });
}

export const getRelatedContent = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/content/get-related-content`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const saveContent = (config = {}) => {
    const { userId, postId, options } = config;
    return api({
      url: `api/content/saved_content_action/`,
      method: 'POST',
      params: { user_id: userId, post_id: postId }, // Query parameters
      ...options,
    });
};

export const savedContentIds = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/content/saved-content`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const getSavedContentIds = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/content/get_saved_content?user_id=${data.user_id}`, // Send as query parameter
        method: "GET",
        ...options,
    });
};

export const searchFilters = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/content/get-filters`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const autoComplete = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/content/autocomplete`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const fetchPostTypePageHeading = (options = {}) => {
    return api({
        url: `api/content/post_type_page_heading`,
        method: 'GET',
        ...options,
    });
}